export function cleanupObject<T extends object>(obj: T): Partial<T> {
  const cleaned: Partial<T> = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== null) {
      cleaned[key] = obj[key];
    }
  }
  return cleaned;
}